import apiHeader from '@/helpers/apiHeader'

const queryTemplateService = {
    list(params) {
        return apiHeader.get('general-setting/query-template', {params});
    },
    detail(id) {
        return apiHeader.get(`general-setting/query-template/${id}`);
    },
    create(params) {
        return apiHeader.post('general-setting/query-template', params);
    },
    update(id, params) {
        return apiHeader.patch(`general-setting/query-template/${id}`, params);
    },
    delete(id) {
        return apiHeader.delete(`general-setting/query-template/${id}`);
    }
}

export default queryTemplateService;